import { Button } from '@wtfalch/design';
import { useEffect } from 'react';
import { useReleaseStatus } from './newVersion.ts';

export const BUILD_ID: string = import.meta.env.VITE_BUILD_ID ?? 'dev';
export const BUILD_RELEASE: number = Number(import.meta.env.VITE_BUILD_RELEASE) || 0;

/**
 * Offers a reload when a newer build is live -- never forced, a person's
 * open work is never reloaded for them. When this build is below the
 * deploy's forced minimum, or any call of the app's own came back 426,
 * there is no offer and no choice: the page reloads at once. A typed draft
 * is never held only here in memory, so nothing is lost (agora#528).
 */
export function NewVersionBanner({
  ownId = BUILD_ID,
  ownRelease = BUILD_RELEASE,
  fetchImpl,
}: {
  ownId?: string;
  ownRelease?: number;
  fetchImpl?: typeof fetch;
}) {
  const { newVersion, forced } = useReleaseStatus(ownId, ownRelease, fetchImpl);

  useEffect(() => {
    if (forced) window.location.reload();
  }, [forced]);

  if (forced) {
    return (
      <div
        role="status"
        className="fixed inset-x-4 bottom-4 z-50 mx-auto flex max-w-md items-center justify-center gap-3 rounded-lg border border-current/20 bg-[var(--surface,canvas)] p-3 shadow-lg"
      >
        <span>Updating to a safe version</span>
      </div>
    );
  }

  if (!newVersion) return null;
  return (
    <div
      role="status"
      className="fixed inset-x-4 bottom-4 z-50 mx-auto flex max-w-md items-center justify-between gap-3 rounded-lg border border-current/20 bg-[var(--surface,canvas)] p-3 shadow-lg"
    >
      <span>A new version is ready</span>
      <Button kind="primary" onPress={() => window.location.reload()}>
        Reload
      </Button>
    </div>
  );
}
